export function maskTelephone(data: string | undefined) {
  if (data) {
    const cleanedData = data.replace(/\D/g, '');

    if (cleanedData.length === 11) {
      return cleanedData.replace(
        /^(\d{2})(\d{1})(\d{4})(\d{4})$/,
        '($1) $2 $3-$4',
      );
    }
    if (cleanedData.length === 10) {
      return cleanedData.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }

    return data;
  }

  return null;
}
